export const userTableDefaultColumns = [
  { id: 'firstAndLastName', label: 'User', isVisible: true, disabled: true, root: true },
  { id: 'devices', label: 'Devices', isVisible: true, disabled: false },
  { id: 'rootProject', label: 'Root project', isVisible: true, disabled: false },
  { id: 'email', label: 'Email', isVisible: true, disabled: false },
  { id: 'trail', label: 'Trail', isVisible: true, disabled: false },
  { id: 'edit', label: 'Edit', isVisible: true, disabled: true, hidden: true }
];
